import { useEffect, useState } from "react"

const AdminOrderModals = ({
  selectedOrder,
  mode, // "view" | "update"
  onClose,
  onUpdated,
}) => {
  const [minQty, setMinQty] = useState(1)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (selectedOrder) {
      setMinQty(selectedOrder.prod_min_qty || 1)
    }
  }, [selectedOrder])

  if (!selectedOrder) return null

  const currentQty = selectedOrder.current_qty || 0
  const isReady = currentQty >= minQty

  /* =========================
     UPDATE HANDLER
  ========================= */

  const handleUpdate = async () => {
    try {
      setSaving(true)

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/orders/${selectedOrder._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            prod_min_qty: minQty,
          }),
        },
      )

      if (!res.ok) throw new Error("Update failed")

      onUpdated()
      onClose()
    } catch (err) {
      console.error("❌ Update error:", err)
      alert("Failed to update order")
    } finally {
      setSaving(false)
    }
  }

  /* =========================
     UI
  ========================= */

  return (
    <div className="modal d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          {/* HEADER */}
          <div className="modal-header">
            <h5 className="modal-title">
              {mode === "view" ? "Order Details" : "Update Order"}
            </h5>
            <button className="btn-close" onClick={onClose} />
          </div>

          {/* BODY */}
          <div className="modal-body">
            <h5 className="mb-3">{selectedOrder.product_name}</h5>

            <div className="row mb-3">
              <div className="col">
                <strong>Current Qty:</strong> {currentQty}
              </div>

              <div className="col">
                <strong>Status:</strong>{" "}
                <span
                  className={`badge ${
                    isReady ? "bg-success" : "bg-warning text-dark"
                  }`}
                >
                  {isReady ? "Ready" : "Pending"}
                </span>
              </div>
            </div>

            {/* UPDATE MODE */}
            {mode === "update" ? (
              <div className="mb-3">
                <label className="form-label">Minimum Quantity</label>
                <input
                  type="number"
                  min="1"
                  className="form-control"
                  value={minQty}
                  onChange={(e) =>
                    setMinQty(Math.max(1, Number(e.target.value)))
                  }
                />
              </div>
            ) : (
              <div className="mb-3">
                <strong>Minimum Quantity:</strong> {selectedOrder.prod_min_qty}
              </div>
            )}

            {/* USER ORDERS */}
            <div className="mt-4">
              <h6>User Orders</h6>

              {!selectedOrder.user_orders?.length ? (
                <p className="text-muted">No user orders</p>
              ) : (
                <div className="border rounded p-2">
                  {selectedOrder.user_orders.map((u, i) => (
                    <div
                      key={i}
                      className="d-flex justify-content-between border-bottom py-1"
                    >
                      <span>
                        {u.user?.username ||
                          u.user?.email ||
                          u.user ||
                          "Unknown"}
                      </span>
                      <span>Qty: {u.qty}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>

            {mode === "update" && (
              <button
                className="btn btn-primary"
                onClick={handleUpdate}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save Changes"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminOrderModals
